import { useTranslation } from 'react-i18next';
import { NavPills, NavItem } from 'app/components';
import { Outlet } from '@tanstack/react-router';
import { useDocumentParams } from 'app/router/params';
import { usePermissions } from 'app/api/permission-queries';

export const DesignSettings = () => {
  const { t } = useTranslation('project-settings');

  const { documentId } = useDocumentParams();
  const { documentPermissions } = usePermissions(documentId);

  const items: NavItem[] = [
    { text: t('theme-configuration'), to: '/documents/$documentId/design', params: { documentId } },
    { text: t('areas'), to: '/documents/$documentId/design/areas', params: { documentId } },
    { text: t('page-numbering'), to: '/documents/$documentId/design/page-numbering', params: { documentId } },
    { text: t('fonts'), to: '/documents/$documentId/design/fonts', params: { documentId } },
  ];

  if (documentPermissions.includes('CODER')) {
    items.push({ text: t('custom-css'), to: '/documents/$documentId/design/css', params: { documentId } });
  }

  return (
    <>
      <div className="mt-5">
        <NavPills items={items} className="d-inline-flex" />
      </div>
      <Outlet />
    </>
  );
};
